import EtablissementNom from '@/generated/controls/etablissement/EtablissementNom.vue';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: EtablissementNom
})
